import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import PropTypes from 'prop-types';

const PdfVisualizer = (props): JSX.Element => {
  const { url } = props;
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  const [numPages, setNumPages] = useState<number|null>(null);
  const [pageNumber, setPageNumber] = useState<number>(1);

  // To Prevent right click on screen
  document.addEventListener('contextmenu', (event) => {
    event.preventDefault();
  });

  // When document gets loaded successfully
  function onDocumentLoadSuccess(_numPages): void {
    setNumPages(_numPages);
    setPageNumber(1);
  }

  function changePage(offset): void {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  }

  function previousPage(): void {
    changePage(-1);
  }

  function nextPage(): void {
    changePage(1);
  }

  return (
    <div>
      <div className="main">
        <Document
          file={url}
          onLoadSuccess={
            (np): void => {
              onDocumentLoadSuccess(np?._pdfInfo?.numPages);
            }
          }
          className="document-div"
        >
          <div className="buttonc">
            <button
              type="button"
              disabled={pageNumber <= 1}
              onClick={previousPage}
              style={{ marginRight: 10 }}
              className="Pre"

            >
              Anterior
            </button>
            <button
              type="button"
              disabled={pageNumber >= numPages}
              onClick={nextPage}

            >
              Próxima
            </button>
          </div>
          <Page height={500} width={500} pageNumber={pageNumber} />
        </Document>
        <div>
          <div className="pagec">
            {pageNumber || (numPages ? 1 : '--')}
            {' '}
            de
            {numPages || '--'}
          </div>
          <div className="buttonc">
            <button
              type="button"
              disabled={pageNumber <= 1}
              onClick={previousPage}
              style={{ marginRight: 10 }}
              className="Pre"

            >
              Anterior
            </button>
            <button
              type="button"
              disabled={pageNumber >= numPages}
              onClick={nextPage}

            >
              Próxima
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

PdfVisualizer.propTypes = {
  url: PropTypes.string.isRequired,
};
PdfVisualizer.defaultProps = {};

export default PdfVisualizer;
